<template lang="html">
  <article class="Post">
    <a v-bind:href="post.link">
      <div class="Thumbnail">
        <img v-bind:src="getThumbnail" alt="">
      </div>
      <div class="Text">
        <p>{{ date }}</p>
        <h3>{{ post.title.rendered }}</h3>
      </div>
    </a>
  </article>
</template>

<script>
import WPURL from '../wp_url';

const postURL = `${WPURL}wp-json/wp/v2/posts?_embed`;

export default {
  name: 'Post',
  props: {
    post: {
      type: Object,
      default() {
        return {
          id: 0,
          slug: '',
          date: '',
          link: '',
          title: { rendered: '' },
          content: { rendered: '' },
          _embedded: '',
        };
      },
    },
  },

  mounted() {
    if (!this.post.id) {
      this.getPost();
      this.isSingle = true;
    }
  },

  data() {
    return {
      base_path: postURL,
      isSingle: false,
    };
  },
  computed: {
    /* eslint no-underscore-dangle: ["error", { "allow": ["_embedded"] }] */
    getThumbnail() {
      if (this.post.featured_media !== 0) {
        const thumbnailHtml = this.post._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url;
        return thumbnailHtml;
      }
      const initThumbnail = '../assets/images/common/thumbnail.png';
      return initThumbnail;
    },
    date() {
      const date = new Date(this.post.date);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return `${y}.${m}.${d}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/stylesheets/_mixin.scss';
  a {
    color: inherit;
  }
  .Post {
    width: 196px;
    margin: 0 auto;
  }
  .Text {
    padding: 2em;
    background-color: #fff;
    border-radius: 0 0 6px 6px;
    border-bottom: 4px solid #dcdcdc;
    p {
      margin: 0;
      color: #34aab5;
      font-size: 1.2rem;
      line-height: 1.5;
    }
  }
  h3 {
    font-size: 1.4rem;
    font-family: '游ゴシック' , 'Yu Gothic' , '游ゴシック体' , 'YuGothic' , serif;
    line-height: 1.3;
  }
  .Thumbnail {
    text-align: center;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// Post.vue?6661e666